import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import {
  ConnectionsIcon,
  HomeIcon,
  ObjectivesIcon,
  SettingsIcon,
  SignalsIcon,
} from 'app/common/presentation/icons'

import { MenuItem } from 'components'

import { Profile } from '../Profile'
import styles from './Sidebar.module.scss'
import UserInfo from './UserInfo'

const menuItems = [
  {
    icon: HomeIcon,
    isSelected: (pathname: string) => pathname === '/',
    key: 'home',
    to: '/',
  },
  {
    icon: SignalsIcon,
    isSelected: (pathname: string) => pathname.includes('/signals'),
    key: 'signals',
    to: '/signals',
  },
  {
    icon: ObjectivesIcon,
    isSelected: (pathname: string) => pathname.includes('/objectives'),
    key: 'objectives',
    to: '/objectives',
  },
  {
    icon: ConnectionsIcon,
    isSelected: (pathname: string) => pathname.includes('/connections'),
    key: 'connections',
    to: '/connections',
  },
]

const Sidebar = () => {
  const { t } = useTranslation('sidebar')
  const location = useLocation()

  return (
    <aside className={styles.sidebar}>
      <div>
        <div className={styles.workspace}>
          <Profile />
        </div>
        <nav className={styles.menu} aria-label="Main navigation">
          <ul>
            {menuItems.map(({ icon: Icon, isSelected, key, to }) => (
              <li key={key}>
                <MenuItem
                  icon={Icon}
                  label={t(`menu.${key}`)}
                  selected={isSelected(location.pathname)}
                  to={to}
                />
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className={styles.userSection}>
        <MenuItem
          icon={SettingsIcon}
          label={t('profile.menu.userSettings')}
          state={{ returnTo: `${location.pathname}${location.search}${location.hash}` }}
          to={'/settings/general'}
        />
        <UserInfo />
      </div>
    </aside>
  )
}

export default Sidebar
